import { Modal, Button } from "react-bootstrap";
import { useRecoilState } from "recoil";
import { isModalAtom } from "../../atoms";

function LoginModal() {
  //모달 닫기 제어
  const [, setisMocalopen] = useRecoilState(isModalAtom);
  const handleClose = () => setisMocalopen(false);
  //2초 후 자동 닫기
  setTimeout(() => {
    setisMocalopen(false);
  }, 2000);
  return (
    <>
      <Modal.Header>
        <Modal.Title>Alert</Modal.Title>
      </Modal.Header>
      <Modal.Body>Alert</Modal.Body>
      <Modal.Footer>
        <Button className="btn_close" variant="secondary" onClick={handleClose}>
          닫기
        </Button>
      </Modal.Footer>
    </>
  );
}

export default LoginModal;
